import React, { useEffect, useState } from 'react';
import { useGSAPReveal } from '../util/useGSAPReveal';
import { GithubSvg, Linkedin, Twitter } from '../icons';

export const Findme: React.FC = () => {
  const [isMobileView, setIsMobileView] = useState(false);

  const headerRef = useGSAPReveal({ variant: 'fade-up' });
  const linksRef = useGSAPReveal({ variant: 'fade-up', delay: 0.12 });

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const socialLinks = [
    {
      href: 'https://linkedin.com/in/asimhafeezz',
      label: 'LinkedIn',
      external: true,
      icon: <Linkedin />,
    },
    {
      href: 'https://github.com/asimhafeezz',
      label: 'GitHub',
      external: true,
      icon: <GithubSvg />,
    },
    {
      href: 'https://www.linkedin.com/newsletters/7023338910793523200/',
      label: 'Newsletter',
      external: true,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm9 8.5L5.072 7H18.93L12 11.5zM4 8.868V18h16V8.868l-8 5-8-5z" />
        </svg>
      ),
    },
    {
      href: 'https://huggingface.co/asimhafeez',
      label: 'Hugging Face',
      external: true,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.64 6.36c.78 0 1.41.63 1.41 1.41s-.63 1.41-1.41 1.41-1.41-.63-1.41-1.41.63-1.41 1.41-1.41zm-7.28 0c.78 0 1.41.63 1.41 1.41s-.63 1.41-1.41 1.41-1.41-.63-1.41-1.41.63-1.41 1.41-1.41zM12 17.5c-2.33 0-4.32-1.45-5.12-3.5h10.24c-.8 2.05-2.79 3.5-5.12 3.5z" />
        </svg>
      ),
    },
    {
      href: 'https://twitter.com/asimhafeezz',
      label: 'Twitter',
      external: true,
      icon: <Twitter />,
    },
  ];

  return (
    <section
      style={{
        minHeight: isMobileView ? 'auto' : '72vh',
        background: 'transparent',
        padding: isMobileView ? '88px 20px' : '140px 80px',
        fontFamily: "'Inter', sans-serif",
        position: 'relative',
      }}
    >
      <div
        style={{
          maxWidth: '1220px',
          margin: '0 auto',
          borderTop: '1px solid rgba(245, 245, 245, 0.05)',
          paddingTop: isMobileView ? '40px' : '56px',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: isMobileView ? '1fr' : 'minmax(320px, 0.92fr) minmax(0, 1.08fr)',
            gap: isMobileView ? '44px' : '72px',
            alignItems: 'start',
          }}
        >
          <div ref={headerRef}>
            <div
              style={{
                width: '44px',
                height: '2px',
                background: '#C4956A',
                marginBottom: '26px',
              }}
            />

            <p
              style={{
                fontSize: '12px',
                color: '#C4956A',
                letterSpacing: '0.18em',
                textTransform: 'uppercase',
                margin: '0 0 18px 0',
                fontWeight: 500,
              }}
            >
              Let&apos;s Connect
            </p>

            <h2
              style={{
                fontSize: isMobileView ? '40px' : '56px',
                fontWeight: 600,
                color: '#F5F5F5',
                fontFamily: "'Space Grotesk', sans-serif",
                letterSpacing: '-0.025em',
                lineHeight: 1.06,
                margin: '0 0 22px 0',
                maxWidth: '540px',
              }}
            >
              If the work feels aligned, reach out.
            </h2>

            <p
              style={{
                fontSize: isMobileView ? '16px' : '18px',
                color: '#8B8B90',
                lineHeight: 1.75,
                margin: '0 0 30px 0',
                maxWidth: '480px',
              }}
            >
              For serious collaborations, consulting, writing, or engineering conversations, email is the best place to start.
            </p>

            <a
              href="mailto:asimhafeezz@icloud.com"
              className="findme-primary"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                padding: '15px 28px',
                borderRadius: '999px',
                background: '#C4956A',
                color: '#100E0D',
                textDecoration: 'none',
                fontSize: '15px',
                fontWeight: 600,
                border: '1px solid rgba(196, 149, 106, 0.18)',
                boxShadow: '0 10px 26px rgba(196, 149, 106, 0.14)',
                transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
              }}
            >
              Send email
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="findme-primary-arrow"
                style={{ transition: 'transform 0.3s ease' }}
              >
                <line x1="7" y1="17" x2="17" y2="7" />
                <polyline points="7 7 17 7 17 17" />
              </svg>
            </a>
          </div>

          <div ref={linksRef}>
            <div
              style={{
                borderTop: '1px solid rgba(245, 245, 245, 0.06)',
              }}
            >
              {socialLinks.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  target={item.external ? '_blank' : undefined}
                  rel={item.external ? 'noopener noreferrer' : undefined}
                  className="findme-row"
                  style={{
                    display: 'grid',
                    gridTemplateColumns: isMobileView ? '1fr auto' : 'minmax(0, 1fr) auto',
                    alignItems: 'center',
                    gap: '16px',
                    padding: isMobileView ? '18px 0' : '20px 0',
                    borderBottom: '1px solid rgba(245, 245, 245, 0.06)',
                    textDecoration: 'none',
                    color: 'inherit',
                    transition: 'all 0.3s ease',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                    <div
                      className="findme-row-icon"
                      style={{
                        width: isMobileView ? '38px' : '40px',
                        height: isMobileView ? '38px' : '40px',
                        borderRadius: '999px',
                        border: '1px solid rgba(245, 245, 245, 0.08)',
                        background: 'rgba(255, 255, 255, 0.015)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#B3B3B8',
                        flexShrink: 0,
                        transition: 'all 0.3s ease',
                      }}
                    >
                      {item.icon}
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', minHeight: isMobileView ? '38px' : '40px' }}>
                      <div
                        className="findme-row-value"
                        style={{
                          fontSize: isMobileView ? '19px' : '21px',
                          color: '#ECECEC',
                          lineHeight: 1.3,
                          transition: 'color 0.3s ease, transform 0.3s ease',
                          fontFamily: "'Space Grotesk', sans-serif",
                          fontWeight: 500,
                          letterSpacing: '-0.01em',
                        }}
                      >
                        {item.label}
                      </div>
                    </div>
                  </div>

                  <span
                    className="findme-row-arrow"
                    style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '999px',
                      border: '1px solid rgba(245, 245, 245, 0.08)',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#8B8B90',
                      background: 'rgba(255, 255, 255, 0.015)',
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="7" y1="17" x2="17" y2="7" />
                      <polyline points="7 7 17 7 17 17" />
                    </svg>
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .findme-primary:hover {
          background: #D4A87A !important;
          transform: translateY(-2px);
          box-shadow: 0 14px 32px rgba(196, 149, 106, 0.2);
        }

        .findme-primary:hover .findme-primary-arrow {
          transform: translate(3px, -3px);
        }

        .findme-row:hover .findme-row-value {
          color: #F5F5F5 !important;
        }

        .findme-row:hover .findme-row-icon {
          color: #C4956A !important;
          border-color: rgba(196, 149, 106, 0.28) !important;
          background: rgba(196, 149, 106, 0.08) !important;
        }

        .findme-row:hover .findme-row-arrow {
          background: #C4956A !important;
          border-color: #C4956A !important;
          color: #100E0D !important;
          transform: translate(2px, -2px);
        }
      `}</style>
    </section>
  );
};
